// The help icon is now in the header on all authenticated pages:
// - AdminLayout pages (header)
// - ProjectDetail (header)
// - SessionTopBar (header)
// The floating button is no longer needed. This component is kept as a no-op
// in case future pages need a floating fallback.
export function HelpButton() {
  return null;
}
